export default __webpack_public_path__ + "images/0xcf0f95e34f25d1bb3d9cad3cbb2eb40dab7c3841.png";